import Attribute from "./Attribute"
import {CategoryGet} from "../../api/CategoriesApi"
import AttributesApi from "../../api/AttributesApi"
import {action, makeAutoObservable} from "mobx"


export default class Category {
    get collection_url(): string | undefined {
        return this._collection_url;
    }

    private _collection_url?: string;

    constructor(id: number, data?: CategoryGet) {
        this._id = id
        if (data) {
            this._wa_categories = data.wa_categories
            this._fullTitle = data.fullTitle
            this._productCount = data.products_count
            this._requiredCount = data.required.count_required
            this._countRequiredWithRules = data.required.count_required_with_rules
            this._collection_url = data.collection_url
        } else {
            this._wa_categories = []
            this._fullTitle = ""
        }
        this._is_attributes_load = false
        makeAutoObservable(this)
    }

    private _id: number

    get id(): number {
        return this._id;
    }

    private _attributes: Attribute[] = []

    get attributes(): Attribute[] {
        return this._attributes;
    }

    private _productCount: number | undefined

    get productCount(): number | undefined {
        return this._productCount
    }

    private _requiredCount: number | undefined

    get requiredCount(): number | undefined {
        return this._requiredCount
    }

    private _countRequiredWithRules: number | undefined

    get countRequiredWithRules(): number | undefined {
        return this._countRequiredWithRules
    }

    private _is_attributes_load: boolean

    get is_attributes_load(): boolean {
        return this._is_attributes_load
    }

    set is_attributes_load(value: boolean) {
        this._is_attributes_load = value
    }

    private _wa_categories: string[]

    get wa_categories(): string[] {
        return this._wa_categories
    }

    private _fullTitle: string

    get fullTitle(): string {
        return this._fullTitle
    }


    loadAttributes() {
        AttributesApi.getAttributes(+this._id).then(
            action("attributesLoaded", (result) => {
                this._fullTitle = result.data.data.category_title;
                for (const attribute of result.data.data.attributes) {
                    const attributeObj = new Attribute(this._id, attribute)
                    this._attributes.push(attributeObj)
                }
                this.is_attributes_load = true
            }))
    }


}